import Joyride, { CallBackProps, STATUS, Step } from "react-joyride";
import { useEffect, useState } from "react";
import { get, set } from "lockr";

const desktopSteps: Step[] = [
  {
    target: ".dashboard-header",
    content:
      "👋🏻 Welcome to Menutender CMS! You can manage your menu and track activities from your dashboard.",
    disableBeacon: true,
  },
  {
    target: ".new-segment",
    content:
      "🏷️ Our segments feature helps you set different price list for the same product. Create one to get started!",
  },
  {
    target: ".barcode-generator",
    content:
      "📸 Enter a table number here to generate scannable barcodes for quick ordering.",
  },
  {
    target: ".settings",
    content:
      "⚙️ Visit your settings to personalize your account, manage preferences, and update your business info.",
  },
  {
    target: ".navigate",
    content:
      "👆 Everything you need is just one click away!. You can navigate to access all sections of the CMS. ",
  },
];

const mobileSteps: Step[] = [
  {
    target: ".mobile-dashboard",
    content:
      "👋🏻 Welcome to Menutender CMS! You can manage your menu and track activities from your dashboard.",
    disableBeacon: true,
  },
  {
    target: ".mobile-new-segment",
    content:
      "🏷️ Our segments feature helps you set different price list for the same product. Create one to get started!",
  },
  {
    target: ".mobile-navigate",
    content:
      "👆 Everything you need is just one click away!. You can navigate to access all sections of the CMS.",
  },
];

const OnboardingWizard = () => {
  const [onboardingJoyride, setOnboardingJoyride] = useState(false);
  const [steps, setSteps] = useState<Step[]>([]);

  useEffect(() => {
    const dontShowWizard = get("dontShowWizard");
    const hasSeenWizard = get("hasSeenWizard");
    const isMobile = window.innerWidth < 900;
    const selectedSteps = isMobile ? mobileSteps : desktopSteps;

    if (dontShowWizard) {
      setSteps(selectedSteps);
      setOnboardingJoyride(false);
      return;
    }

    if (!hasSeenWizard) {
      setSteps(selectedSteps);
      setOnboardingJoyride(true);
    }
  }, []);

  const handleJoyrideCallback = (data: CallBackProps) => {
    const { status } = data;

    if (status === STATUS.FINISHED) {
      set("hasSeenWizard", "true");
      setOnboardingJoyride(false);
    } else if (status === STATUS.SKIPPED) {
      set("dontShowWizard", "true");
      setOnboardingJoyride(false);
    }
  };

  return (
    <Joyride
      steps={steps}
      run={onboardingJoyride}
      continuous
      showProgress
      showSkipButton
      disableScrolling
      scrollToFirstStep
      spotlightPadding={10}
      callback={handleJoyrideCallback}
      styles={{
        options: {
          zIndex: 9999,
        },
        tooltipContainer: {
          textAlign: "left",
          fontWeight: "500",
        },
        buttonBack: {
          marginRight: 10,
          color: "#3d3a39",
          fontSize: "14px",
        },
        buttonNext: {
          backgroundColor: "#6e151e",
          color: "#fff",
          fontSize: "14px",
        },
        buttonSkip: {
          color: "#481217ee",
          fontSize: "14px",
        },
      }}
      locale={{
        last: "Finish",
        skip: "Don't show again",
      }}
    />
  );
};

export default OnboardingWizard;
